AgrimarketServices.service('languageService', ['$rootScope', '$http', '$location', 'currentUserFactory', 'configurationFactory',
    function ($rootScope, $http, $location, currentUserFactory, configurationFactory) {

    	var SendRequest = function (configfile, callback) {
    		$http(configfile)
			    .success(function (data) {
			    	callback(data, null);
			    })
			    .error(function (data, status) {
			    	callback(data, status);
			    });
    	};

    	this.GetLanguages = function (callback) {
    		var config = {
    			method: 'GET',
    			url: configurationFactory.Url['Api'] + 'Language/GetLanguages'
    		};
    		SendRequest(config, callback);
        };

        this.GetDefaultLanguage = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'Language/GetDefaultLanguage'
            };
            SendRequest(config, callback);
        };

    }]);